import { useCallback, useEffect, useState } from 'react';
import {
  getLocalStorageItem,
  LOCAL_STORAGE_KEYS,
  setLocalStorageItem,
} from '@/shared/utils/localStorageUtils';
import { getTehranTodayString } from '@/shared/utils/tehranTime';

/** Last campaign day (inclusive), in Tehran. */
const CAMPAIGN_END_DATE = '2026-07-23';

function isCampaignActive(): boolean {
  return getTehranTodayString() <= CAMPAIGN_END_DATE;
}

function shouldShowCommissionBanner(): boolean {
  const lastDismissedDate = getLocalStorageItem(
    LOCAL_STORAGE_KEYS.COMMISSION_BANNER_LAST_DISMISSED_DATE
  );
  const today = getTehranTodayString();

  if (isCampaignActive()) {
    return lastDismissedDate !== today;
  }

  return lastDismissedDate === null;
}

function markCommissionBannerDismissed(): void {
  setLocalStorageItem(LOCAL_STORAGE_KEYS.COMMISSION_BANNER_LAST_DISMISSED_DATE, getTehranTodayString());
}

export function useCommissionUpdateBannerModal(enabled: boolean) {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!enabled) {
      setIsOpen(false);
      return;
    }

    setIsOpen(shouldShowCommissionBanner());
  }, [enabled]);

  const dismiss = useCallback(() => {
    markCommissionBannerDismissed();
    setIsOpen(false);
  }, []);

  return { isOpen, dismiss };
}
